export default "__VITE_ASSET__CFZsVFHh__"